<template>
  <div
    :class="{'q-pt-md q-pt-sm-sm': listIndex > 0}"
  >
    <slot v-if="hasLabelSlot" name="label" />
    <component
      :is="tableComponent"
      :class="listClass"
      :separator="separator"
      class="separator-end"
      v-bind="tableProps"
    >
      <slot />
    </component>
  </div>
</template>

<script>
import { QList } from 'quasar'
import { markRaw } from 'vue'

export default {
  props: {
    listClass: {
      type: [String, Object]
    },
    listIndex: {
      type: Number,
      default: 0
    },
    separator: {
      type: Boolean,
      default: false
    },
    tableComponent: {
      type: [Function, Object, String],
      default: markRaw(QList)
    },
    tableProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    hasLabelSlot () {
      return !!this.$slots.label
    }
  }
}
</script>
